module.exports = __webpack_public_path__ + "img/stock7.337d6aac.png";